import { render } from "./WorkflowSettingApiModelHistory.vue?vue&type=template&id=8143f66c"
import script from "./WorkflowSettingApiModelHistory.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingApiModelHistory.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__